import OracleDeckGrid from '../../components/oracle/OracleDeckGrid';

function OracleDeckGridPage({ lang = 'es' }) {
  return (
    <main className="bg-gray-900 min-h-screen py-10">
      <OracleDeckGrid lang={lang} />
    </main>
  );
}

export default OracleDeckGridPage;